import React, { useRef } from "react";
import { motion, useInView } from "framer-motion";
import { Facebook, Instagram } from "lucide-react";

const faculty = [
  {
    name: "Nanda Gopal V V",
    role: "Founder, Mathematics Lead",
    sub: "",
    img: "https://images.unsplash.com/photo-1633332755192-727a05c4013d?auto=format&fit=crop&w=900&q=80",
    accent: "#4ECDC4",
    muted: "rgba(255,255,255,0.75)",
  },
  {
    name: "Revanth T",
    role: "Physical science lead· 7 yrs",
    sub: "",
    img: "https://images.unsplash.com/photo-1535713875002-d1d0cf377fde?auto=format&fit=crop&w=900&q=80",
    accent: "#FF6B6B",
    muted: "rgba(255,255,255,0.8)",
  },
  {
    name: "Parvathi Venugopal",
    role: "Commerce & Economics · 8 yrs",
    sub: "",
    img: "https://images.unsplash.com/photo-1580489944761-15a19d654956?auto=format&fit=crop&w=900&q=80",
    accent: "#0B132B",
    muted: "rgba(255,255,255,0.7)",
  },
  {
    name: "Devika Sujith ",
    role: "Natural science lead · 7 yrs",
    sub: "",
    img: "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?auto=format&fit=crop&w=900&q=80",
    accent: "#FCA311",
    muted: "rgba(11,19,43,0.7)",
  },
];

export default function Faculty() {
  const gridRef = useRef(null);
  const isGridInView = useInView(gridRef, { once: true, amount: 0.2, margin: "0px 0px -10% 0px" });

  const sectionVariants = {
    hidden: {},
    visible: {
      transition: { staggerChildren: 0.12, delayChildren: 0.15 },
    },
  };

  const cardVariants = {
    hidden: { opacity: 0, y: 36, scale: 0.96, rotate: -1.2 },
    visible: {
      opacity: 1,
      y: 0,
      scale: 1,
      rotate: 0,
      transition: { duration: 0.7, ease: [0.22, 1, 0.36, 1] },
    },
  };

  return (
    <section
      id="faculty"
      data-testid="faculty-section"
      className="px-6 md:px-12 lg:px-16 py-24 md:py-32"
      style={{ background: "var(--bg-tertiary)" }}
    >
      <div className="max-w-[1400px] mx-auto">
        <div className="mb-16 grid grid-cols-1 md:grid-cols-12 gap-8 items-end">
          <div className="md:col-span-7">
            <div className="text-[11px] tracking-[0.25em] uppercase font-bold text-[#FF6B6B] mb-4">
              ✦ Faculty
            </div>
            <h2 className="font-display font-black text-4xl sm:text-5xl md:text-6xl text-[#0B132B] tracking-tighter leading-[0.95]">
              Mentors who show up <br />
              with heart and clarity.
            </h2>
          </div>
          <p className="md:col-span-5 text-lg text-[#3A506B] leading-relaxed">
            Hand-picked educators who build confidence, not just marks. Every mentor is trained in the LearnWithNova teaching method.
          </p>
        </div>

        <motion.div
          className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6"
          ref={gridRef}
          variants={sectionVariants}
          initial="hidden"
          animate={isGridInView ? "visible" : "hidden"}
        >
          {faculty.map((f, i) => (
            <motion.div
              key={f.name}
              variants={cardVariants}
              whileHover={{ y: -10, rotate: -0.6, scale: 1.01 }}
              whileTap={{ scale: 0.99 }}
              data-testid={`faculty-card-${i}`}
              className="faculty-card group rounded-[28px] border border-white/10 px-7 py-8 sm:px-8 sm:py-9 min-h-[320px] flex flex-col justify-between shadow-[0_18px_45px_rgba(11,19,43,0.18)] transition-transform duration-300"
              style={{ background: f.accent, color: f.muted }}
            >
              <div>
                <div className="text-[10px] tracking-[0.25em] uppercase font-bold text-white/70">
                  Faculty {String(i + 1).padStart(2, "0")}
                </div>
                <h3 className="font-display text-2xl sm:text-3xl font-black tracking-tight text-white mt-4">
                  {f.name}
                </h3>
                <div className="text-sm sm:text-base text-white/90 mt-2">{f.role}</div>
                <div className="text-xs sm:text-sm mt-5 leading-relaxed" style={{ color: f.muted }}>
                  {f.sub}
                </div>
              </div>
              <div className="mt-10 flex items-center gap-4">
                {[Facebook, Instagram].map((Icon, idx) => (
                  <button
                    key={idx}
                    type="button"
                    aria-label="social"
                    className="w-10 h-10 rounded-full grid place-items-center bg-white/12 text-white/90 transition-colors hover:bg-white/20"
                  >
                    <Icon size={16} />
                  </button>
                ))}
              </div>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
}
